// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";

import * as sharedSelectors from "@modules/shared/selectors";
import * as serviceSelectors from "@modules/service/selectors";
import actionCreator from "@modules/service/actionCreator";
import type { StepProps } from "@components";
import { HierarchyScopeForm } from "@modules/service/components/hierarchy-scope";
import type { HierarchyTree } from "@modules/shared/reducer/hierarchy/types";
import type { HierarchyAssignment } from "@modules/service/types";
import type { Alert } from "@modules/service/reducer/alerts/types";

type OwnProps = $Exact<{
  editing: boolean,
}>;

type PropsFromState = $Exact<{
  schema: ?Object,
  draft: ?Alert,
  assignments: Array<HierarchyAssignment>,
  hierarchy: ?HierarchyTree,
}>;

type PropsFromDispatch = $Exact<{
  setAssignments: typeof actionCreator.SetAlertAssignments,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...StepProps,
  ...PropsFromLocalize,
}>;

export class Step7HierarchyScope extends React.Component<Props> {
  updateAssignments = (data: Array<HierarchyAssignment>) => {
    this.props.setAssignments(data);
  };

  render() {
    if (!this.props.editable) {
      return <div />;
    }

    return (
      <div className="w-100 d-flex justify-content-center">
        <div className="col-sm-12">
          {this.props.hierarchy && (
            <HierarchyScopeForm
              hierarchy={this.props.hierarchy}
              assignments={this.props.assignments}
              onChange={this.updateAssignments}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps): PropsFromState => {
  return {
    schema: serviceSelectors.getAlertSchema(state),
    draft: serviceSelectors.getAlertDraft(state),
    assignments: serviceSelectors.getAlertAssignments(state),
    hierarchy: sharedSelectors.getHierarchyTree(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  setAssignments: actionCreator.SetAlertAssignments,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(Step7HierarchyScope);
